"use client";
import { useState, useEffect } from "react";
import { MdClose } from "react-icons/md";

const Toast = ({ message, duration = 3000 }: { message: string; duration?: number }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [message, duration]);

  if (!isVisible) return null;

  return (
    <div className="fixed -right-32 bottom-20 -translate-x-1/2 transform rounded-md bg-attention p-4 text-white">
      <div className="flex items-center">
        <span className="min-w-[232px] text-xs font-bold">{message}</span>
        <MdClose onClick={() => setIsVisible(false)} />
      </div>
    </div>
  );
};

export default Toast;
